import { useMutation, useQueryClient } from '@tanstack/react-query'

import type {
  BookingSessionResponse,
  CreateBookingSessionRequest,
} from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'

export const useCreateBookingSession = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreateBookingSessionRequest) => {
      const response = await apiClient.client.post<BookingSessionResponse>('/booking-session', data)
      return response.data
    },
    onSuccess: (data) => {
      syncBookingSessionCache(queryClient, data)
    },
  })
}
